module.exports = __webpack_public_path__ + "img/b6.242d4fa5.png";